/*
 *  Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 *  Author Rihard Tsybulka <rykhard.tsybulka@noogadev.com>
 */

import { CashBoxesStats } from '../../api/cashBoxes/cashBoxesClient.typings';
import { CompanyDetailsDto } from '../../api/companies/companiesClient.typings';
import {
    TaxpayerAccDetailsActions,
    TaxpayerAccDetailsActionType,
} from '../../actions/TaxpayerAcc/TaxpayerAccDetailsActions';

export interface TaxpayerAccDetailsState {
    companyDetails: CompanyDetailsDto;
    companyCashBoxesStats: CashBoxesStats;
    isLoading: boolean;
    isLoadingCashBoxesStats: boolean;
}

export const initialState: TaxpayerAccDetailsState = {
    companyDetails: null,
    companyCashBoxesStats: null,
    isLoading: false,
    isLoadingCashBoxesStats: false,
};

function taxpayerAccDetailsReducer(
    state: TaxpayerAccDetailsState = initialState,
    action: TaxpayerAccDetailsActions,
): TaxpayerAccDetailsState {
    switch (action.type) {
        case TaxpayerAccDetailsActionType.OPEN_TAXPAYER_ACC_HOME_PAGE:
            return {
                ...state,
                isLoading: true,
                isLoadingCashBoxesStats: true,
            };

        case TaxpayerAccDetailsActionType.FETCH_TAXPAYER_ACC_DETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                companyDetails: action.payload,
            };

        case TaxpayerAccDetailsActionType.FETCH_TAXPAYER_ACC_CASHBOXES_STATS_SUCCESS:
            return {
                ...state,
                isLoadingCashBoxesStats: false,
                companyCashBoxesStats: action.payload,
            };

        case TaxpayerAccDetailsActionType.FETCH_TAXPAYER_ACC_HOME_DATA_ERROR:
            return {
                ...state,
                isLoading: false,
                isLoadingCashBoxesStats: false,
            };

        case TaxpayerAccDetailsActionType.EXIT_TAXPAYER_ACC_HOME_PAGE:
            return {
                ...state,
                companyDetails: null,
                companyCashBoxesStats: null,
            };

        default:
            return state;
    }
}

export default taxpayerAccDetailsReducer;
